/**
 * Vitrine analytics tracker — lightweight, RGPD-friendly.
 * - Generates a stable anonymous visitor_id in localStorage (1 year).
 * - Sends { path, referrer, visitor_id } on each public page view.
 * - Fire-and-forget via sendBeacon when available; fallback to fetch.
 */
const LS_KEY = "cmes_vid";
const ONE_YEAR_MS = 365 * 24 * 3600 * 1000;

function getVisitorId() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.id && parsed?.exp && Date.now() < parsed.exp) return parsed.id;
    }
  } catch {}
  const id = (crypto.randomUUID && crypto.randomUUID()) || `v_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({ id, exp: Date.now() + ONE_YEAR_MS }));
  } catch {}
  return id;
}

export function trackPageview(path) {
  try {
    const backend = process.env.REACT_APP_BACKEND_URL;
    if (!backend) return;
    const url = `${backend}/api/public/analytics/pageview`;
    const payload = JSON.stringify({
      path: path || window.location.pathname,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    });
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {}
}
